import React, { useState, useEffect } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
   
    Box,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { fetchCategories } from '../services/Apis';



const Filter = () => {
    const [expanded, setExpanded] = useState(null);
    const [categoriesData, setCategoriesData] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        const getCategories = async () => {
            setLoading(true);
            const data = await fetchCategories();
           
                setCategoriesData(data);
                setLoading(false);
            
        };
        getCategories();
    }, []);

    const handleToggle = (index) => {
        setExpanded(expanded === index ? null : index);
    };

    return (
        <Box sx={{ backgroundColor: '#fff', borderRadius: 2 }}>
            {/* Header */}
            <Box
                sx={{
                    backgroundColor: '#CB4422',
                    padding: '10px 16px',
                    color: '#fff',
                    fontWeight: 600,
                    fontFamily: 'Poppins',
                    fontSize: 14,
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                }}
            >
                All Categories
            </Box>

            {/* Accordions */}
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 120 }}>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <span className="red-dot" />
                        <span className="red-dot" style={{ animationDelay: '0.2s' }} />
                        <span className="red-dot" style={{ animationDelay: '0.4s' }} />
                    </Box>
                    <style>
                        {`
                        .red-dot {
                            display: inline-block;
                            width: 14px;
                            height: 14px;
                            border-radius: 50%;
                            background: #CB4422;
                            margin: 0 4px;
                            animation: bounce 1s infinite;
                        }
                        @keyframes bounce {
                            0%, 80%, 100% { transform: scale(1); opacity: 1; }
                            40% { transform: scale(1.4); opacity: 0.7; }
                        }
                        `}
                    </style>
                </Box>
            ) : (
                categoriesData
                    .filter(cat => cat.isActive) // Only show active categories
                    .map((cat, index) => (
                        <Accordion
                            key={index}
                            expanded={expanded === index}
                            onChange={() => handleToggle(index)}
                            disableGutters
                            sx={{
                                boxShadow: 'none',
                                borderBottom: '1px solid #eee',
                                '&::before': { display: 'none' },
                            }}
                        >
                            <AccordionSummary
                                expandIcon={
                                    <i
                                        className={`fa-solid ${expanded === index ? 'fa-minus' : 'fa-plus'}`}
                                        style={{ fontSize: 14, color: '#CB4422' }}
                                    ></i>
                                }
                                sx={{
                                    minHeight: '40px',
                                    padding: '0 16px',
                                    fontFamily: 'Poppins',
                                    fontWeight: expanded === index ? 600 : 500,
                                    color: expanded === index ? '#CB4422' : '#333',
                                    fontSize: 14,
                                }}
                            >
                                {cat.title || cat.name}
                            </AccordionSummary>
                            {cat.subCategories && cat.subCategories.length > 0 && (
                                <AccordionDetails sx={{ py: 0 }}>
                                    <List dense>
                                        {cat.subCategories.map((sub, idx) => (
                                            <ListItem key={idx} disablePadding>
                                                <ListItemButton disableRipple disableTouchRipple  onClick={() => navigate(`/filtered-books?subcat=${sub.id}`)} sx={{ px: 3 }}>
                                                    <ListItemText
                                                        primary={sub.name}
                                                        primaryTypographyProps={{
                                                            fontSize: 13,
                                                            fontFamily: 'Poppins', fontWeight: 400,
                                                        }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                    </List>
                                </AccordionDetails>
                            )}
                        </Accordion>
                    ))
            )}
        </Box>
    );
};

export default Filter;